import { classicProjectFieldsEntryPoint } from '@jira/project-settings__classic-project-fields/src/classicProjectFieldsEntryPoint.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';

import { softwareProjectLayout } from '@atlassian/jira-software-project-layout/src/index.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { GENERIC_BUSINESS_TRANSITIONAL_PROJECT_HORIZONTAL_NAV } from '@atlassian/jira-navigation-apps-horizontal-nav-selector/src/constants.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { classicProjectSettingsSoftwareFieldsRoute } from '@atlassian/jira-router-routes-project-settings-product-routes-software-routes/src/classicProjectSettingsSoftwareFieldsRoute.tsx';
import AsyncSidebarNextGen from '@atlassian/jira-navigation-apps-sidebar-next-gen/src/async.tsx';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point';
import { getSettingsNavigationResources } from './ui/project-settings/product-routes/common/index.tsx';

const pageEntryPoint = createPageEntryPoint({
	main: classicProjectFieldsEntryPoint,
	topNavigationMenuId: MENU_ID.PROJECTS,
});
export const classicProjectSettingsSoftwareFieldsRouteEntry = createEntry(
	classicProjectSettingsSoftwareFieldsRoute,
	() => ({
		group: 'project-settings-software',
		ufoName: 'project-settings.fields.jsw-cmp',
		layout: softwareProjectLayout,
		navigation: {
			horizontal: GENERIC_BUSINESS_TRANSITIONAL_PROJECT_HORIZONTAL_NAV,
			menuId: MENU_ID.PROJECTS,
			sidebar: AsyncSidebarNextGen,
			sidebarId: SIDEBAR_ID.PROJECT_SETTINGS,
		},
		canTransitionIn: () => fg('jira_efa_for_cmp_m4_fields'),
		resources: [...getSettingsNavigationResources()],
		entryPoint: () => {
			if (!fg('jira_efa_for_cmp_m4_fields')) {
				return undefined;
			}
			return pageEntryPoint;
		},
		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-project-settings-product-routes-software-entries/src/classicProjectSettingsSoftwareFieldsRouteEntry.tsx',
				whichExportToUse: 'classicProjectSettingsSoftwareFieldsRouteEntry',
			},

			enabled: true,
		},
		meta: {
			reporting: {
				packageName: 'jiraClassicProjectSettingsProjectFields',
				id: 'project-settings.fields.jsw-cmp',
				teamName: 'Yamato',
			},
		},
	}),
);
